// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__vNzco","title":"AfterBackImages_title__6UmA5","images":"AfterBackImages_images__2XZuY"};